import type React from 'react';
import type { SearchParams } from '../types';
import styles from "../styles/HotelSearch.module.scss"
import i18n from '../../i18n';
import FormCheckBoxButton from '../../Form/FormCheckBoxButton';

type SearchFormFilteringSpProps = {
  featuredAreaCodes: string[];
  query: SearchParams,
  onChangeQuery: (query: SearchParams) => void
}

const SearchFormFilteringSp: React.FC<SearchFormFilteringSpProps> = ({ featuredAreaCodes, query, onChangeQuery }) => {
  return (
    <div className={styles.resortFilteringBarWrapper}>
      <span className={styles.resortFilteringBarTitle}>{i18n.t('stay_packages.hotels.index.filter_by_popular_1')}<br/>{i18n.t('stay_packages.hotels.index.filter_by_popular_2')}</span>
      <div className={styles.resortItems}>
        <FormCheckBoxButton
          id='checkbox-hoshino-resorts'
          label={i18n.t('stay_packages.shared.hoshino_resort')}
          checked={query.forHoshinoResort}
          onClick={() => onChangeQuery({...query, forHoshinoResort: !query.forHoshinoResort})}
        />
        <FormCheckBoxButton
          id='checkbox-ski-in-out'
          label={i18n.t('stay_packages.hotels.index.ski_in_ski_out')}
          checked={query.skiInOut}
          onClick={() => onChangeQuery({...query, skiInOut: !query.skiInOut})}
          />
        <FormCheckBoxButton
          id='checkbox-hot-spring'
          label={i18n.t('stay_packages.hotels.index.hot_spring_available')}
          checked={query.hotSpring}
          onClick={() => onChangeQuery({...query, hotSpring: !query.hotSpring})}
        />
        </div>
    </div>
  );
}

export default SearchFormFilteringSp;
